import { render, staticRenderFns } from "./Vector.vue?vue&type=template&id=648f1433&scoped=true"
import script from "./Vector.vue?vue&type=script&lang=js"
export * from "./Vector.vue?vue&type=script&lang=js"
import style0 from "./Vector.scss?vue&type=style&index=0&id=648f1433&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f1433",
  null
  
)

export default component.exports